<template>
    <FormSection
        title="Additional UB-04 Locators"
        type="his-section"
        :full-height="false"
        :application-id="application"
    >
        <template #content>
            <section class="row py-3 pb-0 g-0">
                <div class="col-12 col-lg-6 px-4 col-md-12 g-0">
                    <div class="col-12 py-2">
                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center">
                                <b class="me-2"> (UB-04 Locators 31 - 34) Occurrence Codes</b>
                            </p>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label id="Referral_31A_code" for="referral-31a-code"> 31A Code: </label>
                                <input
                                    id="Referral_31A_code"
                                    name="referral-31a-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="
                                        referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator31a
                                            .Code
                                    "
                                />
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-12">
                                <label for="31a-date"> Date: </label>
                                <DatePicker :getDate="onDateChange">
                                    <div class="input-group date datepickerInput">
                                        <input
                                            name="31a-date"
                                            type="text"
                                            class="form-control"
                                            autocomplete="off"
                                            :value="
                                                referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                    .Locator31a.Date
                                            "
                                            @change="handleDateChange"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                    </div>
                                </DatePicker>
                            </div>
                            <template v-if="showOccurenceCodes">
                                <div class="form-group col-12 col-lg-12 pe-lg-2">
                                    <label id="Referral_32A_code" for="referral-32a-code"> 32A Code: </label>
                                    <input
                                        id="Referral_32A_code"
                                        name="referral-32a-code"
                                        class="form-control"
                                        maxlength="2"
                                        placeholder="Enter code"
                                        type="text"
                                        v-model="
                                            referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator32a
                                                .Code
                                        "
                                    />
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="32a-date"> Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="32a-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator32a.Date
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-2">
                                    <label id="Referral_33A_code" for="referral-33a-code"> 33A Code: </label>
                                    <input
                                        id="Referral_33A_code"
                                        name="referral-33a-code"
                                        class="form-control"
                                        maxlength="2"
                                        placeholder="Enter code"
                                        type="text"
                                        v-model="
                                            referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator33a
                                                .Code
                                        "
                                    />
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="33a-date"> Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="33a-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator33a.Date
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-2">
                                    <label id="Referral_34A_code" for="referral-34a-code"> 34A Code: </label>
                                    <input
                                        id="Referral_34A_code"
                                        name="referral-34a-code"
                                        class="form-control"
                                        maxlength="2"
                                        placeholder="Enter code"
                                        type="text"
                                        v-model="
                                            referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator34a
                                                .Code
                                        "
                                    />
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="34a-date"> Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="34a-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator34a.Date
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-2">
                                    <label id="Referral_31B_code" for="referral-31b-code"> 31B Code: </label>
                                    <input
                                        id="Referral_31B_code"
                                        name="referral-31b-code"
                                        class="form-control"
                                        maxlength="2"
                                        placeholder="Enter code"
                                        type="text"
                                        v-model="
                                            referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator31b
                                                .Code
                                        "
                                    />
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="31b-date"> Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="31b-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator31b.Date
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-2">
                                    <label id="Referral_32B_code" for="referral-32b-code"> 32B Code: </label>
                                    <input
                                        id="Referral_32B_code"
                                        name="referral-32b-code"
                                        class="form-control"
                                        maxlength="2"
                                        placeholder="Enter code"
                                        type="text"
                                        v-model="
                                            referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator32b
                                                .Code
                                        "
                                    />
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="32b-date"> Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="32b-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator32b.Date
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-2">
                                    <label id="Referral_33B_code" for="referral-33b-code"> 33B Code: </label>
                                    <input
                                        id="Referral_33B_code"
                                        name="referral-33b-code"
                                        class="form-control"
                                        maxlength="2"
                                        placeholder="Enter code"
                                        type="text"
                                        v-model="
                                            referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator33b
                                                .Code
                                        "
                                    />
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="33b-date"> Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="33b-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator33b.Date
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-2">
                                    <label id="Referral_34B_code" for="referral-34b-code"> 34B Code: </label>
                                    <input
                                        id="Referral_34B_code"
                                        name="referral-34a-code"
                                        class="form-control"
                                        maxlength="2"
                                        placeholder="Enter code"
                                        type="text"
                                        v-model="
                                            referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator34b
                                                .Code
                                        "
                                    />
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="34b-date"> Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="34b-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator34b.Date
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                            </template>
                            <div class="col-12 py-2">
                                <div class="mt-1">
                                    <button class="btn btn-xs btn-primary p-1" @click="toogleShowOccurenceCode">
                                        <span v-if="!showOccurenceCodes">View Occurence Codes</span>
                                        <span v-else>Hide Occurence Codes</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 px-4 col-md-12 g-0">
                    <div class="col-12 py-2">
                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center">
                                <b class="me-2"> (UB-04 Locators 35 - 36) Occurrence Span</b>
                            </p>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-12 pe-lg-2">
                                <label id="Referral_35A_code" for="referral-35a-code"> 35A Code: </label>
                                <input
                                    id="Referral_35A_code"
                                    name="referral-35a-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="
                                        referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator35a
                                            .Code
                                    "
                                />
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-12">
                                <label for="35a-start-date"> Start Date: </label>
                                <DatePicker :getDate="onDateChange">
                                    <div class="input-group date datepickerInput">
                                        <input
                                            name="35a-start-date"
                                            type="text"
                                            class="form-control"
                                            autocomplete="off"
                                            :value="
                                                referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                    .Locator35a.DateFrom
                                            "
                                            @change="handleDateChange"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                    </div>
                                </DatePicker>
                            </div>
                            <div class="form-group col-12 col-lg-12 pe-lg-12">
                                <label for="35a-end-date"> End Date: </label>
                                <DatePicker :getDate="onDateChange">
                                    <div class="input-group date datepickerInput">
                                        <input
                                            name="35a-end-date"
                                            type="text"
                                            class="form-control"
                                            autocomplete="off"
                                            :value="
                                                referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                    .Locator35a.DateThrough
                                            "
                                            @change="handleDateChange"
                                        />
                                        <div class="input-group-addon input-group-append">
                                            <div class="input-group-text">
                                                <i class="fa fa-calendar"></i>
                                            </div>
                                        </div>
                                    </div>
                                </DatePicker>
                            </div>
                            <template v-if="showOccurenceSpan">
                                <div class="form-group col-12 col-lg-12 pe-lg-2">
                                    <label id="Referral_36A_code" for="referral-36a-code"> 36A Code: </label>
                                    <input
                                        id="Referral_36A_code"
                                        name="referral-36a-code"
                                        class="form-control"
                                        maxlength="2"
                                        placeholder="Enter code"
                                        type="text"
                                        v-model="
                                            referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator36a
                                                .Code
                                        "
                                    />
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="36a-start-date"> Start Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="36a-start-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator36a.DateFrom
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="36a-end-date"> End Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="36a-end-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator36a.DateThrough
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-2">
                                    <label id="Referral_35B_code" for="referral-35b-code"> 35B Code: </label>
                                    <input
                                        id="Referral_35B_code"
                                        name="referral-35b-code"
                                        class="form-control"
                                        maxlength="2"
                                        placeholder="Enter code"
                                        type="text"
                                        v-model="
                                            referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator35b
                                                .Code
                                        "
                                    />
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="35b-start-date"> Start Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="35b-start-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator35b.DateFrom
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="35b-end-date"> End Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="35b-end-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator35b.DateThrough
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-2">
                                    <label id="Referral_36B_code" for="referral-36b-code"> 36B Code: </label>
                                    <input
                                        id="Referral_36B_code"
                                        name="referral-36b-code"
                                        class="form-control"
                                        maxlength="2"
                                        placeholder="Enter code"
                                        type="text"
                                        v-model="
                                            referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator36b
                                                .Code
                                        "
                                    />
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="36b-start-date"> Start Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="36b-start-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator36b.DateFrom
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                                <div class="form-group col-12 col-lg-12 pe-lg-12">
                                    <label for="36b-end-date"> End Date: </label>
                                    <DatePicker :getDate="onDateChange">
                                        <div class="input-group date datepickerInput">
                                            <input
                                                name="36b-end-date"
                                                type="text"
                                                class="form-control"
                                                autocomplete="off"
                                                :value="
                                                    referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator36b.DateThrough
                                                "
                                                @change="handleDateChange"
                                            />
                                            <div class="input-group-addon input-group-append">
                                                <div class="input-group-text">
                                                    <i class="fa fa-calendar"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </DatePicker>
                                </div>
                            </template>
                            <div class="col-12 py-2">
                                <div class="mt-1">
                                    <button class="btn btn-xs btn-primary p-1" @click="toogleShowOccurenceSpan">
                                        <span v-if="!showOccurenceSpan">View Occurence Span</span>
                                        <span v-else>Hide Occurence Span</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-12 px-4 col-md-12 g-0">
                    <div class="col-12 py-2">
                        <div class="w-100">
                            <p class="mb-2 d-flex align-items-center">
                                <b class="me-2"> (UB-04 Locators 18 - 28) Condition Codes</b>
                            </p>
                        </div>
                        <div class="row">
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_18_code" for="referral-18-code"> 18: </label>
                                <input
                                    id="Referral_18_code"
                                    name="referral-18-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code18"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_19_code" for="referral-19-code"> 19: </label>
                                <input
                                    id="Referral_19_code"
                                    name="referral-19-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code19"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_20_code" for="referral-20-code"> 20: </label>
                                <input
                                    id="Referral_20_code"
                                    name="referral-20-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code20"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_21_code" for="referral-21-code"> 21: </label>
                                <input
                                    id="Referral_21_code"
                                    name="referral-21-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code21"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_22_code" for="referral-22-code"> 22: </label>
                                <input
                                    id="Referral_22_code"
                                    name="referral-22-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code22"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_23_code" for="referral-23-code"> 23: </label>
                                <input
                                    id="Referral_23_code"
                                    name="referral-23-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code23"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_24_code" for="referral-24-code"> 24: </label>
                                <input
                                    id="Referral_24_code"
                                    name="referral-24-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code24"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_25_code" for="referral-25-code"> 25: </label>
                                <input
                                    id="Referral_25_code"
                                    name="referral-25-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code25"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_26_code" for="referral-26-code"> 26: </label>
                                <input
                                    id="Referral_26_code"
                                    name="referral-26-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code26"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_27_code" for="referral-27-code"> 27: </label>
                                <input
                                    id="Referral_27_code"
                                    name="referral-27-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code27"
                                />
                            </div>
                            <div class="form-group col-12 col-lg-3 pe-lg-2">
                                <label id="Referral_28_code" for="referral-28-code"> 28: </label>
                                <input
                                    id="Referral_28_code"
                                    name="referral-28-code"
                                    class="form-control"
                                    maxlength="2"
                                    placeholder="Enter code"
                                    type="text"
                                    v-model="referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code28"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./AdditionalUBLocators.ts"></script>
